const inCompleteQuestionnaire = {
  id: 664,
  answers: {
    3756: {
      order: 1,
      answer: '21',
      isCurrent: false,
      fromPrevious: false,
    },
    3757: {
      order: 88,
      answer: 'Female',
      isCurrent: false,
      fromPrevious: false,
    },
  },
  status: 'inProgress',
  percentage: 50,
  hasNewVersion: false,
  startedAt: '2021-01-11T11:34:28.934Z',
  endedAt: '2021-01-12T10:01:34.891Z',
  retakeCount: 2,
  createdAt: '2020-05-14T07:57:10.274Z',
  updatedAt: '2021-01-12T10:01:34.891Z',
  createdBy: null,
  updatedBy: 173,
  userId: 173,
  user: {
    id: 173,
    user_detail: {
      firstName: 'Test Name',
      lastName: 'Test LastName',
    },
  },
  updatedByUser: {
    id: 173,
    user_detail: {
      firstName: 'Test Name',
      lastName: 'Test LastName',
    },
  },
  assessmentId: {
    id: 39,
    imageUrl:
      'https://evolve-filemanager.s3.us-west-2.amazonaws.com/dev/private/1_1649808331520_Demographics.png?AWSAccessKeyId=AKIAXJH6Z5MSP46QXYVB&Expires=1671837197&Signature=bMlfkalnNRI1gpMrlNfvc9w0FOQ%3D',
  },
  reminderId: null,
  assessment: {
    name: 'Demographics Questionnaire    ',
    lastMessage:
      '<p></p>\n<p style="text-align:center;"><span style="font-size: 16px;"><strong>Congratulations!</strong></span></p>\n<p style="text-align:center;">You just completed the <strong>Demographics Questionnaire</strong>.😍</p>\n<p style="text-align:center;">We use your answers to generate personal health recommendations to review and discuss with your provider. Each questionnaire you complete makes your recommendations more personalized.</p>\n<p></p>\n<p></p>\n',
    firstMessage:
      '<p>We’re asking your age, sex, gender identity, race/ethnicity, height and weight to figure out your risk of weight-related medical problems and design a personalized treatment plan.</p>\n',
    questions: [
      {
        id: 3760,
      },
      {
        id: 3756,
      },
      {
        id: 3757,
      },
      {
        id: 3758,
      },
      {
        id: 3759,
      },
      {
        id: 3761,
      },
    ],
  },
};
const newQuestionnaire = {
  id: 665,
  answers: {
    2276: {
      order: 1,
      answer: null,
    },
  },
  status: 'new',
  percentage: 0,
  hasNewVersion: false,
  startedAt: '2020-05-14T07:57:10.274Z',
  endedAt: '2021-01-12T10:01:34.891Z',
  retakeCount: 0,
  createdAt: '2020-05-14T07:57:10.274Z',
  updatedAt: '2021-01-12T10:01:34.891Z',
  createdBy: null,
  updatedBy: 173,
  userId: 173,
  user: {
    id: 173,
    user_detail: {
      firstName: 'Test Name',
      lastName: 'Test LastName',
    },
  },
  updatedByUser: {
    id: 173,
    user_detail: {
      firstName: 'Test Name',
      lastName: 'Test LastName',
    },
  },
  assessmentId: {
    id: 38,
    imageUrl:
      'https://evolve-filemanager.s3.us-west-2.amazonaws.com/dev/private/1_1574118805157_iStock-1085259850-cropped.png?AWSAccessKeyId=AKIAXJH6Z5MSP46QXYVB&Expires=1671837197&Signature=aGhtbRubaOFTG88b9iCtzcNNfAM%3D',
  },
  reminderId: null,
  assessment: {
    name: 'Weight History Questionnaire',
    lastMessage:
      '<p><p style="text-align:center;"><span style="font-size: 16px;"><strong>Congratulations!</strong></span></p><p style="text-align:center;">You just completed the <strong>Weight History Questionnaire</strong>.</p><p style="text-align:center;">We use your answers to generate personal health recommendations to review and discuss with your provider. Each questionnaire you complete makes your recommendations more personalized.</p><p style="text-align:center;"></p></p>',
    firstMessage:
      '<p>We’re asking about your weight history to put things in perspective.&nbsp;For example, there are changes that occur in your body after losing weight that may impact future weight loss efforts.</p>',
    questions: [
      {
        id: 2278,
      },
      {
        id: 2277,
      },
    ],
  },
};

export const patientAnswers = {
  total: 1,
  limit: 10,
  skip: 0,
  data: [
    {
      id: 663,
      answers: [
        {
          questionId: '2365',
          questionContent: 'Do you ever feel that your appetite is excessive or do you ever feel hungry again within one to two hours of eating?',
          questionType: 'scale',
          answer: {
            order: 6,
            answer: null,
          },
        },
      ],
      status: 'new',
      percentage: 50,
      hasNewVersion: false,
      startedAt: '2021-01-11T11:34:28.934Z',
      endedAt: '2021-01-12T10:01:34.891Z',
      retakeCount: 2,
      createdAt: '2020-05-14T07:57:10.274Z',
      updatedAt: '2021-01-12T10:01:34.891Z',
      createdBy: null,
      updatedBy: 173,
      userId: 173,
      user: {
        id: 173,
        user_detail: {
          firstName: 'Test Name',
          lastName: 'Test LastName',
        },
      },
      updatedByUser: {
        id: 173,
        user_detail: {
          firstName: 'Test Name',
          lastName: 'Test LastName',
        },
      },
      assessmentId: {
        id: 743,
        imageUrl:
          'https://evolve-filemanager.s3.us-west-2.amazonaws.com/test/private/1_1574119021033_iStock-1065941082-cropped.png?AWSAccessKeyId=AKIAXJH6Z5MSP46QXYVB&Expires=1613350174&Signature=Dc7HbGrQMN4S59m0iLbE51S6ag4%3D',
      },
      passedBy: null,
      reminderId: 891,
      assessment: {
        name: 'Food Cravings and Appetite Questionnaire',
        lastMessage:
          '<p><p style="text-align:center;"><strong>Congratulations!</strong></p>\n<p style="text-align:center;">You just completed the <strong>Food Cravings and Appetite Questionnaire</strong>.</p>\n<p style="text-align:center;">We use your answers to generate personal health recommendations to review and discuss with your provider. Each questionnaire you complete makes your recommendations more personalized.</p>\n<p></p>\n</p>',
        firstMessage:
          '<p>Sometimes we eat when we’re not hungry. Identifying situations when this happens or emotions that make us want to eat can be helpful to reduce or prevent eating when we’re not hungry.</p>',
        questions: [
          {
            id: 2368,
          },
        ],
      },
    },
  ],
};

export const questionnaireData = {
  total: 1,
  limit: 10,
  skip: 0,
  data: [
    {
      id: 654,
      answers: {
        1593: {
          order: 1,
          answer: ['Stressful', 'Free/junk food available', 'Frequent travel', 'Long hours'],
        },
        1594: {
          order: 2,
          answer: '0',
        },
        1595: {
          order: 3,
          answer: '0',
        },
        1596: {
          order: 4,
          answer: true,
        },
        1597: {
          order: 5,
          answer: 'No',
        },
        1599: {
          order: 6,
          answer: 'No',
        },
      },
      status: 'completed',
      percentage: 75,
      hasNewVersion: false,
      startedAt: '2020-05-08T12:17:08.356Z',
      endedAt: '2020-05-08T12:18:09.116Z',
      retakeCount: 0,
      createdAt: '2020-05-08T12:17:08.356Z',
      updatedAt: '2020-05-08T12:18:09.116Z',
      createdBy: null,
      updatedBy: null,
      userId: 200,
      user: {
        id: 200,
        user_detail: {
          firstName: 'Test Name',
          lastName: 'Test LastName',
        },
      },
      updatedByUser: {
        id: 173,
        user_detail: {
          firstName: 'Test Name',
          lastName: 'Test LastName',
        },
      },
      assessmentId: {
        id: 10,
        imageUrl: '',
      },
      passedBy: null,
      reminderId: null,
      assessment: {
        name: 'Lifestyle Factors Questionnaire',
        lastMessage:
          '<p><p style="text-align:center;"><span style="font-size: 16px;"><strong>Congratulations!</strong></span></p>\n<p style="text-align:center;">You just completed the <strong>Lifestyle Factors Questionnaire</strong>.</p>\n<p style="text-align:center;">We use your answers to generate personal health recommendations to review and discuss with your provider. Each questionnaire you complete makes your recommendations more personalized.</p>\n</p>',
        firstMessage:
          '<p>There are certain aspects of your schedule that can make it harder to lose weight. Understanding these can help to address each one specifically.</p>',
        questions: [
          {
            id: 1598,
          },
          {
            id: 1599,
          },
          {
            id: 1594,
          },
          {
            id: 1595,
          },
          {
            id: 1596,
          },
          {
            id: 1597,
          },
          {
            id: 1593,
          },
          {
            id: 1600,
          },
        ],
      },
    },
    {
      id: 743,
      answers: {
        2360: {
          order: 1,
          answer: ['Stress'],
        },
        2361: {
          order: 2,
          answer: true,
        },
        2362: {
          order: 3,
          answer: 1,
        },
        2363: {
          order: 4,
          answer: 1,
        },
        2364: {
          order: 5,
          answer: '0-25%',
        },
        2365: {
          order: 6,
          answer: 1,
        },
        2366: {
          order: 7,
          answer: 1,
        },
        2367: {
          order: 8,
          answer: true,
        },
        2368: {
          order: 9,
          answer: 'No',
        },
      },
      status: 'completed',
      percentage: 90,
      hasNewVersion: false,
      startedAt: '2021-04-08T01:43:06.865Z',
      endedAt: '2021-04-08T01:43:34.387Z',
      retakeCount: 2,
      createdAt: '2020-06-03T10:22:56.374Z',
      updatedAt: '2021-04-08T01:43:34.388Z',
      createdBy: null,
      updatedBy: 174,
      userId: 174,
      user: {
        id: 200,
        user_detail: {
          firstName: 'Test Name',
          lastName: 'Test LastName',
        },
      },
      updatedByUser: null,
      assessmentId: {
        id: 42,
        imageUrl: '',
      },
      passedBy: null,
      reminderId: null,
      assessment: {
        name: 'Medical History Questionnaire',
        lastMessage:
          '<p><p style="text-align:center;"><strong>Congratulations!</strong></p>\n<p style="text-align:center;">You just completed the <strong>Food Cravings and Appetite Questionnaire</strong>.</p>\n<p style="text-align:center;">We use your answers to generate personal health recommendations to review and discuss with your provider. Each questionnaire you complete makes your recommendations more personalized.</p>\n<p></p>\n</p>',
        firstMessage:
          '<p>Sometimes we eat when we’re not hungry. Identifying situations when this happens or emotions that make us want to eat can be helpful to reduce or prevent eating when we’re not hungry.</p>',
        questions: [
          {
            id: 2368,
          },
          {
            id: 2360,
          },
          {
            id: 2365,
          },
          {
            id: 2361,
          },
          {
            id: 2362,
          },
          {
            id: 2363,
          },
          {
            id: 2367,
          },
          {
            id: 2364,
          },
          {
            id: 2366,
          },
          {
            id: 2369,
          },
        ],
      },
    },
    inCompleteQuestionnaire,
    newQuestionnaire,
  ],
};
export const questions = {
  assessmentName: 'Medical History Questionnaire',
  status: 'completed',
  user: {
    id: 200,
    user_detail: {
      firstName: 'Test Name',
      lastName: 'Test LastName',
    },
  },
  percentage: 73,
  firstMessage:
    '<p>Certain medical problems can be associated with a higher body weight and many of these medical problems can improve or resolve with weight loss.</p>\n',
  lastMessage:
    '<p><p style="text-align:center;"><span style="font-size: 16px;"><strong>Congratulations!</strong></span></p>\n<p style="text-align:center;">You just completed the <strong>Medical History Questionnaire</strong>.</p>\n<p style="text-align:center;">We use your answers to generate personal health recommendations to review and discuss with your provider. Each questionnaire you complete makes your recommendations more personalized.</p>\n<p></p>\n</p>',
  isLast: true,
  questionnaire: [
    {
      question: {
        id: 2393,
        content: 'Please list your current medication(s).',
        questionType: 'item-search',
        variableUnit: null,
        answers: [],
        config: [
          {
            field: 'multipleSelection',
            value: 'true',
          },
          {
            field: 'allowOther',
            value: 'true',
          },
          {
            field: 'item-search',
            value: 'Medications',
          },
          {
            field: 'customList',
            value: false,
          },
          {},
        ],
        variable: {
          id: 52,
          name: 'medications',
          type: 'array',
          unitType: null,
        },
      },
      userAnswer: {
        order: 5,
        answer: ['none'],
      },
    },
    {
      question: {
        id: 2394,
        content: 'Are you currently taking any supplement(s) for weight loss?',
        questionType: 'yes/no',
        variableUnit: null,
        answers: [],
        config: [],
        variable: null,
      },
      userAnswer: {
        order: 6,
        answer: 'No',
      },
    },
    {
      question: {
        id: 2398,
        content: 'We have a few questions that are specific to women….Are you: ',
        questionType: 'multiple-choice',
        variableUnit: null,
        answers: ['Nursing ', 'On birth control', 'Pregnant', 'Trying to conceive', 'None of the above', 'Does not apply'],
        config: [
          {
            field: 'multipleSelection',
            value: 'true',
          },
          {
            field: 'allowOther',
            value: 'true',
          },
        ],
        variable: {
          id: 29,
          name: 'Female concerns',
          type: 'array',
          unitType: null,
        },
      },
      userAnswer: {
        order: 8,
        answer: ['Does not apply'],
      },
    },
    {
      question: {
        id: 1891,
        content: 'How active is your average day?',
        questionType: 'multiple-choice',
        variableUnit: null,
        answers: [
          'Sedentary (e.g., desk job, no structured activity)',
          'Lightly active (e.g., some light activity in daily life)',
          'Moderately active (e.g., light activity in daily life plus structured activity several times per week)',
          'Very active (e.g., active daily life plus structured activity several times per week)',
        ],
        config: [
          {
            field: 'multipleSelection',
            value: false,
          },
          {
            field: 'allowOther',
            value: null,
          },
        ],
        variable: {
          id: 31,
          name: 'Activity level',
          type: 'array',
          unitType: null,
        },
      },
      userAnswer: {
        order: 2,
        answer: 'Lightly active (e.g., some light activity in daily life)',
      },
    },
    {
      question: {
        id: 2257,
        content:
          '<p>Certain eating behaviors can make it harder to lose weight. Addressing these can make a big difference to your weight and your health.</p>',
        questionType: 'content',
        variableUnit: null,
        answers: [],
        config: [],
        variable: null,
      },
      userAnswer: {
        order: 6,
        answer: true,
      },
    },
    {
      question: {
        id: 2252,
        content: 'Do you eat simple carbohydrates for breakfast? Examples include bagels, cereal, bread, muffins, instant oatmeal, potatoes. ',
        questionType: 'scale',
        variableUnit: null,
        answers: ['Never', 'Sometimes', 'Always'],
        config: [],
        variable: null,
      },
      userAnswer: {
        order: 1,
        answer: 1,
      },
    },
    {
      question: {
        id: 2168,
        content: 'Please estimate how many hours you sleep per night? ',
        questionType: 'text',
        variableUnit: null,
        answers: [],
        config: [
          {
            field: 'text',
            value: 'Short Answer',
          },
        ],
        variable: {
          id: 65,
          name: 'regular_sleep_hours',
          type: 'string',
          unitType: null,
        },
      },
      userAnswer: {
        order: 2,
        answer: '5',
      },
    },
    {
      question: {
        id: 2277,
        content: 'What year was your highest weight?',
        questionType: 'date/time',
        variableUnit: null,
        answers: [],
        config: [
          {
            field: 'date/time',
            value: 'Date',
          },
          {
            field: 'dateFormat',
            value: 'YYYY',
          },
        ],
        variable: {
          id: 71,
          name: 'Date_HighWeightYear',
          type: 'date',
          unitType: null,
        },
      },
      userAnswer: {
        order: 3,
        answer: '2020',
      },
    },
  ],
  hasNewVersion: false,
};

export const retakeQuestionnaire = {
  assessmentName: 'Medical History Questionnaire',
  status: 'inProgress',
  percentage: 0,
  firstMessage:
    '<p>Certain medical problems can be associated with a higher body weight and many of these medical problems can improve or resolve with weight loss.</p>\n',
  lastMessage:
    '<p><p style="text-align:center;"><span style="font-size: 16px;"><strong>Congratulations!</strong></span></p>\n<p style="text-align:center;">You just completed the <strong>Medical History Questionnaire</strong>.</p>\n<p style="text-align:center;">We use your answers to generate personal health recommendations to review and discuss with your provider. Each questionnaire you complete makes your recommendations more personalized.</p>\n<p></p>\n</p>',
  isLast: false,
  questionnaire: [
    {
      question: {
        id: 2393,
        content: 'Please list your current medication(s).',
        questionType: 'item-search',
        variableUnit: null,
        answers: [],
        config: [
          {
            field: 'multipleSelection',
            value: 'true',
          },
          {
            field: 'allowOther',
            value: 'true',
          },
          {
            field: 'item-search',
            value: 'Medications',
          },
          {
            field: 'customList',
            value: false,
          },
          {},
        ],
        variable: {
          id: 52,
          name: 'medications',
          type: 'array',
          unitType: null,
        },
      },
      userAnswer: {
        order: 5,
        answer: ['none'],
        isCurrent: true,
      },
    },
    {
      question: {
        id: 2394,
        content: 'Are you currently taking any supplement(s) for weight loss?',
        questionType: 'yes/no',
        variableUnit: null,
        answers: [],
        config: [],
        variable: null,
      },
      userAnswer: {
        order: 6,
        answer: 'No',
        isCurrent: false,
        fromPrevious: true,
      },
    },
    {
      question: {
        id: 2398,
        content: 'We have a few questions that are specific to women….Are you: ',
        questionType: 'multiple-choice',
        variableUnit: null,
        answers: ['Nursing ', 'On birth control', 'Pregnant', 'Trying to conceive', 'None of the above', 'Does not apply'],
        config: [
          {
            field: 'multipleSelection',
            value: 'true',
          },
          {
            field: 'allowOther',
            value: 'true',
          },
        ],
        variable: {
          id: 29,
          name: 'Female concerns',
          type: 'array',
          unitType: null,
        },
      },
      userAnswer: {
        order: 8,
        answer: ['Does not apply'],
        isCurrent: false,
        fromPrevious: true,
      },
    },
    {
      question: {
        id: 1891,
        content: 'How active is your average day?',
        questionType: 'multiple-choice',
        variableUnit: null,
        answers: [
          'Sedentary (e.g., desk job, no structured activity)',
          'Lightly active (e.g., some light activity in daily life)',
          'Moderately active (e.g., light activity in daily life plus structured activity several times per week)',
          'Very active (e.g., active daily life plus structured activity several times per week)',
        ],
        config: [
          {
            field: 'multipleSelection',
            value: false,
          },
          {
            field: 'allowOther',
            value: null,
          },
        ],
        variable: {
          id: 31,
          name: 'Activity level',
          type: 'array',
          unitType: null,
        },
      },
      userAnswer: {
        order: 2,
        answer: 'Lightly active (e.g., some light activity in daily life)',
        isCurrent: false,
        fromPrevious: true,
      },
    },
    {
      question: {
        id: 2257,
        content:
          '<p>Certain eating behaviors can make it harder to lose weight. Addressing these can make a big difference to your weight and your health.</p>',
        questionType: 'content',
        variableUnit: null,
        answers: [],
        config: [],
        variable: null,
      },
      userAnswer: {
        order: 6,
        answer: true,
        isCurrent: false,
        fromPrevious: true,
      },
    },
    {
      question: {
        id: 2252,
        content: 'Do you eat simple carbohydrates for breakfast? Examples include bagels, cereal, bread, muffins, instant oatmeal, potatoes. ',
        questionType: 'scale',
        variableUnit: null,
        answers: ['Never', 'Sometimes', 'Always'],
        config: [],
        variable: null,
      },
      userAnswer: {
        order: 1,
        answer: 1,
        isCurrent: false,
        fromPrevious: true,
      },
    },
    {
      question: {
        id: 2168,
        content: 'Please estimate how many hours you sleep per night? ',
        questionType: 'text',
        variableUnit: null,
        answers: [],
        config: [
          {
            field: 'text',
            value: 'Short Answer',
          },
        ],
        variable: {
          id: 65,
          name: 'regular_sleep_hours',
          type: 'string',
          unitType: null,
        },
      },
      userAnswer: {
        order: 2,
        answer: '5',
        isCurrent: false,
        fromPrevious: true,
      },
    },
    {
      question: {
        id: 2277,
        content: 'What year was your highest weight?',
        questionType: 'date/time',
        variableUnit: null,
        answers: [],
        config: [
          {
            field: 'date/time',
            value: 'Date',
          },
          {
            field: 'dateFormat',
            value: 'YYYY',
          },
        ],
        variable: {
          id: 71,
          name: 'Date_HighWeightYear',
          type: 'date',
          unitType: null,
        },
      },
      userAnswer: {
        order: 3,
        answer: '2020',
        isCurrent: false,
        fromPrevious: true,
      },
    },
  ],
  hasNewVersion: false,
};
